export default __webpack_public_path__ + "static/media/LINEAR.c82f497d.svg";